var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import classNames from "classnames";
import React, { Component, Children } from "react";
import { Row, Col } from "@riseart/antd-provider";
import { TabSideItem } from "./Item.js";
import { TabSideContent } from "./Content.js";
import { TabPane } from "../common/Pane";
import { tabsSideCls } from "./Tabs.less";
function isValidChild(child) {
  if (child === null || child.type === TabPane) {
    return true;
  }
  throw new Error("Invalid child component '".concat(child.type, "' passed to <Tabs />. You are only allowed to pass TabPane or null as children in Tabs."));
}
__name(isValidChild, "isValidChild");
var TabSide = /* @__PURE__ */ function(_Component) {
  function TabSide2(props) {
    var _this;
    _classCallCheck(this, TabSide2);
    _this = _callSuper(this, TabSide2, [props]);
    _this.state = {
      selectedTabs: [void 0, null].indexOf(props.active) === -1 ? _toConsumableArray(props.active) : []
    };
    return _this;
  }
  __name(TabSide2, "TabSide");
  _inherits(TabSide2, _Component);
  return _createClass(TabSide2, [{
    key: "handleClick",
    value: (
      /**
       * handleClick
       *
       * @param {number} index
       */
      /* @__PURE__ */ __name(function handleClick(index, childProps) {
        var _this2 = this;
        return function(e) {
          e.preventDefault();
          var _this2$props = _this2.props, onTabChange = _this2$props.onTabChange, multiple = _this2$props.multiple;
          if (onTabChange) {
            onTabChange(index, _this2.state.selectedTabs, childProps);
          }
          _this2.setState(function(currentState) {
            return {
              selectedTabs: currentState.selectedTabs.indexOf(index) > -1 ? currentState.selectedTabs.filter(function(item) {
                return item !== index;
              }) : multiple && [].concat(_toConsumableArray(currentState.selectedTabs), [index]) || [index]
            };
          });
        };
      }, "handleClick")
    )
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props, active = _this$props.active, multiple = _this$props.multiple;
      var selectedTabs = this.state.selectedTabs;
      if (active && prevState.selectedTabs.indexOf(selectedTabs) > -1 && selectedTabs.indexOf(active) === -1) {
        this.setState(function(currentState) {
          return {
            selectedTabs: multiple && [].concat(_toConsumableArray(currentState.selectedTabs), [active]) || [active]
          };
        });
      }
    }, "componentDidUpdate")
    /**
     * renderTabs
     */
  }, {
    key: "renderTabs",
    value: /* @__PURE__ */ __name(function renderTabs() {
      var _this3 = this;
      var children = this.props.children;
      var selectedTabs = this.state.selectedTabs;
      var content = {
        tabs: [],
        content: []
      };
      Children.forEach(children, function(child, idx) {
        if (child === null || !isValidChild(child)) {
          return null;
        }
        var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, disabled = _child$props.disabled;
        var isActive = !disabled && selectedTabs.indexOf(idx) > -1;
        content.tabs.push(/* @__PURE__ */ React.cloneElement(/* @__PURE__ */ React.createElement(TabSideItem, null), {
          key: idx,
          type: "side",
          role: "tab",
          isActive,
          className: headerClass,
          disabled,
          onClick: _this3.handleClick(idx, child.props),
          children: header
        }));
        content.content.push(/* @__PURE__ */ React.cloneElement(/* @__PURE__ */ React.createElement(TabSideContent, null), {
          key: idx,
          isActive,
          children: child.props.children
        }));
      });
      return content;
    }, "renderTabs")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var content = this.renderTabs();
      return /* @__PURE__ */ React.createElement(Row, {
        type: "flex",
        justify: "space-between",
        className: classNames(tabsSideCls, this.props.className)
      }, /* @__PURE__ */ React.createElement(Col, {
        span: 6
      }, /* @__PURE__ */ React.createElement("ul", {
        role: "tablist"
      }, content.tabs)), /* @__PURE__ */ React.createElement(Col, {
        span: 16
      }, content.content));
    }, "render")
  }]);
}(Component);
_defineProperty(TabSide, "defaultProps", {
  className: null,
  multiple: false
});
export {
  TabSide,
  isValidChild
};
